/* eslint-disable */
import React, { Component, useEffect, useState, useMemo } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect, useStore } from "react-redux";
import Helmet from "react-helmet";
import ErrorScreen from "../ErrorScreen/ErrorScreen";
import classnames from "classnames";
import { createStructuredSelector } from "reselect";
import query from "query-string";
import {
  Loader,
  ExternalMarkup,
  PromotionList,
  GoogleAnalytics,
  TripAdvisorPixel,
  ShareBooking,
  MapView,
  DataLayerTracker,
  BMindTracker,
  MessageOverlay,
  RedirectLoadingScreen,
} from "~/components";
import { PORTRAIT_LAYOUT } from "~/components/PromotionList/constants";
import CheckoutAdditionalInfo from "~/components/CheckoutAdditionalInfo/CheckoutAdditionalInfo";
import {
  getFromSessionStorage,
  getPromotions,
  copyURLParams,
  executeEvent,
  redirectUrl,
  redirectTopUrl,
  getFromLocalStorage,
} from "../../utils/misc";
import constants from "../../utils/constants";
import styles from "./App.scss";
import { actions } from "./reducer";
import { fromJS } from "immutable";
import {
  propertyARISelector,
  denormalizedInvalidReservationsSelector,
  messagesSelector,
  promotionsSelector,
  customStylesSelector,
  logosSelector,
  availableCurrenciesSelector,
  currencySelector,
  localeSelector,
  availableLocalesSelector,
  globalLoadingSelector,
  iframeModeSelector,
  showPromosSelector,
  fullWidthSelector,
  isPropertyAvailableSelector,
  isPropertyChainSelector,
  ariLoadingSelector,
  defaultCurrencySelector,
  propertyContactSelector,
  propertyNameSelector,
  creditCardTypesSelector,
  mediaSelector,
  markupsSelector,
  showElementsConfigSelector,
  cancelReleaseSelector,
  reservationCreatedSelector,
  externalConfigurationSelector,
  externalReservationSelector,
  gaDataSelector,
  startDateSelector,
  endDateSelector,
  propertyIsDemoSelector,
  reservationSelector,
  configurationSelector,
  expandedBookablesSelector,
  pendingAmountTextConfigurationSelector,
  analyticsLoadedSelector,
  tripAdvisorLoadedSelector,
  externalMarkupLoadedSelector,
  fullWidthTypeSelector,
  hotelSiteURLSelector,
  isIframeSelector,
  menuMarkupSelector,
  menuButtonMarkupSelector,
  isWithotelSelector,
  wbkDataLayerSelector,
  bMindTrackerSelector,
  propertyDataSelector,
  expandedPromotionsSelector,
  isBookingFormSummaryOpenedSelector,
  unavailableURLSelector,
  channelSelector,
  cookieConsentSelector,
  messageCodeSelector,
  originSelector,
  hideUnavailableURLScreenSelector,
  deviceInfoSelector,
  showNewBookingFormSelector,
  affiliateSelector,
  loyaltySelector,
  encodedAffiliateSelector,
  modeSelector,
} from "./selectors";
import { selectors as reservationSelectors } from "../ReservationManager";
import { defineMessages, FormattedMessage, injectIntl } from "react-intl";
import { Modal } from "~/components";
import { ToastContainer, ToastMessageAnimated } from "react-toastr";
import Notification from "~/components/Notification/Notification";
import ImageGallery from "~/components/ImageGallery/ImageGallery";
import { renderHTML, hexToRGBAString } from "../../utils/misc";
import { StickyContainer, Sticky } from "react-sticky";
import { actions as reservationActions } from "../ReservationManager";
import BookingFormWrapper from "../BookingFormWrapper/index";
import BookingFormWrapperOld from "../BookingFormWrapperOld/BookingFormWrapperOld";
import { requestBookingEngineData, requestReservationData } from "./reducer";
import styled from "styled-components";
import "flexboxgrid/css/flexboxgrid.css";
import prefixes from "../../utils/phoneCountryPrefixes.json";

require("flexboxgrid/css/flexboxgrid.css");
require("sanitize.css/sanitize.css");
import "../../theme/Toaster.scss"; // only needs to be imported once
import "../../theme/ToasterAnimate.scss"; // only needs to be imported once
import Scroll from "react-scroll";
import { ThemeProvider } from "styled-components";
import { theme } from "../../utils/themeBookingForm";

const Element = Scroll.Element;
const scroller = Scroll.scroller;
import { Popup, Conditions, PopupLostReserved } from "@witbooking/react-components";
import { ShoppingCartIcon } from "../../theme/assets";
import { screenResize } from "../../redux/modules/ui";
import GlobalLoader from "../../components/GlobalLoader";
import { withSessionData, useSessionData } from "../../utils/session";
import ExtrasPlaceholder from "../../theme/hotel-bell.png";
import AssistedMode from "../../components/AssistedMode/AssistedMode";
import { ExitStep } from "../../utils/EngineDataColllector/EngineData";
import { addPages, updateExitStep } from "../../utils/EngineDataColllector/EngineDataCollector";
import * as moment from "moment";
import { Url } from "../../contexts/cart-abandonment/domain/Url";

export const appMsgs = defineMessages({
  deletedReservations: {
    id: "app.label.deletedReservations",
    description: "label that shows deleted reservations",
    defaultMessage: "Deleted Reservations:",
  },
  invalidPayments: {
    id: "app.label.invalidPayments",
    description: "label that shows invalid payment message",
    defaultMessage: "Invalid payments!!!",
  },
  bookingShare: {
    id: "app.share_booking.share_booking_cart",
    description: "Header title for the Popup",
    defaultMessage: "Share booking cart",
  },
  agentsTitle: {
    id: "footer.link.agencyEntry",
    description: "Popup Header title",
    defaultMessage: "Agencies",
  },
  IEHeader: {
    id: "app.old_browser.update.header",
    description: "Incompatible Browser",
    defaultMessage: "Incompatible Browser",
  },
  IESubHeader: {
    id: "app.old_browser.update.subheader",
    description: "We recommend updating the browser to have a better booking experience",
    defaultMessage: "We recommend updating the browser to have a better booking experience",
  },
  IEUpdate: {
    id: "app.old_browser.update",
    description: "Update browser",
    defaultMessage: "Update browser",
  },
  affiliateEmail: {
    id: "room_selection.hotel.affiliateEmail",
    description: "Activated agent",
    defaultMessage: "Activated agent",
  },
});

const IEUpdateMessage = styled.div`
  min-height: 60px;
  font-weight: 700;
  background-color: #f09f39;
  color: white;
  display: flex;
  justify-content: space-between;
  padding: 10px;
  & > *:last-child {
    padding: 10px;
    background-color: black;
    width: 20%;
    min-height: 40px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
    text-align: center;
    cursor: pointer;
  }
  & > *:first-child > *:last-child {
    font-weight: 400;
  }
  & a:visited {
    color: white;
  }
  & a:link {
    color: white;
  }
`;

function getExitStep({ pathname, search }) {
  let exitStep = ExitStep.LIST;
  if (search.includes("expand")) {
    exitStep = ExitStep.ROOM;
  }
  if (pathname.includes("checkout")) {
    exitStep = ExitStep.CHECKOUT;
  }
  if (pathname.includes("booking-confirmation")) {
    exitStep = ExitStep.BOOK;
  }
  return exitStep;
}

const addGclidQueryParamToURLAndLocation = (location, previousLocation) => {
  const queryParams = query.parse(location.search);
  const prevQueryParams = query.parse(previousLocation.search);
  if (!queryParams.gclid && prevQueryParams.gclid) {
    const search = `${location.search ? `${location.search}&` : "?"}gclid=${prevQueryParams.gclid}`;
    window.history.replaceState(null, null, search);
    location.search = search;
  }
  return location;
};

export default ({ match, location, history, ...props }) => {
  updateExitStep(getExitStep(location));
  let previousLocation = location;
  history.listen(location => {
    location = addGclidQueryParamToURLAndLocation(location, previousLocation);
    if (
      !previousLocation ||
      previousLocation.pathname !== location.pathname ||
      previousLocation.search !== location.search
    ) {
      previousLocation = location;
      addPages();
    }
  });
  const store = useStore();
  const session = useSessionData(null);
  const sessionLocale = useSessionData("locale");
  const guestData = useSessionData("guestData");
  const impersonate = useSessionData("impersonate");
  const promoCodes = useSessionData("promoCodes");
  const sessionUrlParams = useSessionData("urlParams");
  const [loaded, setLoaded] = useState(false);
  const queryParams = query.parse(location.search);
  const [stayQueueIndex, setStayQueueIndex] = useState(
    getFromSessionStorage(constants.LOCAL_STORAGE_KEYS.STAY_QUEUE_INDEX) || 0
  );

  if (
    moment.locale &&
    store &&
    store.getState() &&
    store.getState().intl &&
    store.getState().intl.locale
  ) {
    moment.locale(store.getState().intl.locale);
  }

  const params = {
    ...queryParams,
    ...match.params,
  };
  if (sessionLocale) {
    params.locale = sessionLocale;
  }
  if (promoCodes) {
    const extraCodes = promoCodes.reduce((prev, next) => `${prev},${next}`);
    params.prom = params.prom ? `${params.prom},${extraCodes}` : extraCodes;
  }
  if (sessionUrlParams) {
    Object.keys(sessionUrlParams).forEach(key => {
      params[key] = sessionUrlParams[key];
    });
  }

  const loyaltyUser = useMemo(() => {
    if (guestData && guestData.jwt) {
      const { brand, tier, countryCode, birthDate, jwt } = guestData;
      return {
        ...guestData,
        jwt,
        country: countryCode,
        birthDate: birthDate ? new Date(`${birthDate} 00:00`) : new Date(),
        brandTicker: brand && brand.ticker && brand.ticker.value,
        tierTicker: tier && tier.ticker && tier.ticker.value,
        impersonate: impersonate,
      };
    }
    return null;
  }, [guestData, impersonate]);

  useEffect(() => {
    const load = async () => {
      // we pass the recovered session information to this method
      // so it might be used in the configurer
      await store.dispatch(requestBookingEngineData(params, session));
      if (params.reservationId) {
        await store.dispatch(requestReservationData(params));
      }
      setLoaded(true);
    };
    load();
  }, []);

  return (
    <>
      {!loaded && <GlobalLoader />}
      {loaded && (
        <>
          <AssistedMode
            stayQueueIndex={stayQueueIndex}
            store={store}
            location={location}
            history={history}
            params={params}
            locale={store.getState().intl.locale}
            {...props}
          />
          <ConnectedApp
            match={match}
            history={history}
            location={location}
            {...props}
            setStayQueueIndex={setStayQueueIndex}
            stayQueueIndex={stayQueueIndex}
            loyaltyUser={loyaltyUser}
          />
        </>
      )}
    </>
  );
};

class App extends Component {
  constructor(props) {
    super(props);
    this.activateResizeListener();
    // Redirect iframes with Universal template
    let isIframeRedirected = false;
    let iframeRedirectError = false;
    this.canOverWriteModal = true;
    const queryParams = query.parse(props.location.search);
    if (props.fullWidth && !queryParams?.noRedirect) {
      if (window.self !== window.top) {
        if (
          window.location &&
          (window.location.search || window.location.search === "") &&
          window.location.search.indexOf("mobileRedirect=0") === -1
        ) {
          if (window.location.pathname && window.location.pathname.indexOf("paynopain") === -1) {
            if (window.location.hostname === "engine.witbooking.com") {
              try {
                redirectTopUrl(window.location.href.replace("witif=1", "witif=0"));
                isIframeRedirected = true;
              } catch (exception) {
                iframeRedirectError = true;
                console.log(exception);
              }
            }
          }
        }
      }
    }
    this.renderModalContent = this.renderModalContent.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.addAlert = this.addAlert.bind(this);
    this.handleGallery = this.handleGallery.bind(this);
    this.handleGalleryClose = this.handleGalleryClose.bind(this);
    this.handleGalleryInventory = this.handleGalleryInventory.bind(this);
    this.handleModalContent = this.handleModalContent.bind(this);
    this.handleMultiConditions = this.handleMultiConditions.bind(this);
    this.createCustomStyles = this.createCustomStyles.bind(this);
    this.handleChangeConfiguration = this.handleChangeConfiguration.bind(this);
    this.handleChangeLocale = this.handleChangeLocale.bind(this);
    this.handleExpandPromotions = this.handleExpandPromotions.bind(this);
    this.handleAnalyticsClientData = this.handleAnalyticsClientData.bind(this);
    this.pushState = this.pushState.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleAddReservation = this.handleAddReservation.bind(this);
    this.handleShareBookingCart = this.handleShareBookingCart.bind(this);
    this.getMapViewCenter = this.getMapViewCenter.bind(this);
    this.getMapMarker = this.getMapMarker.bind(this);
    this.generateMapView = this.generateMapView.bind(this);
    this.handleWithotelMenu = this.handleWithotelMenu.bind(this);
    this.activateResizeListener = this.activateResizeListener.bind(this);
    this.handleResizeEvent = this.handleResizeEvent.bind(this);
    this.state = {
      modal: {
        isOpen: false,
        children: null,
        options: {},
      },
      gallery: {
        isOpen: false,
        images: [],
        title: null,
        description: null,
        inventory: null,
        options: {},
        extraAction: null,
      },
      isIframeRedirected,
      iframeRedirectError,
      redirectToUnavailableURL:
        this.isNotGiftCardSession() &&
        !props.isPropertyAvailable &&
        !props.isPropertyChain &&
        this.isAllowedRedirect(),
      cancelRedirect: false,
    };
    const component = this;
    if (window) {
      window.wbkCloseModal = () => {
        component.handleCloseModal();
      };
    }
    window.wbkIsPropertyAvailable = props.isPropertyAvailable;
    window.wbkIsPropertyChain = props.isPropertyChain;
    window.wbkLanguage = props.locale;
    if (props.customStyles) {
      this.createCustomStyles(props.customStyles, props.fullWidth);
    }
  }

  // TODO: Correct proptpyes
  // static propTypes = {
  //   children: PropTypes.object.isRequired,
  //   push: PropTypes.func.isRequired
  // };
  static contextTypes = {
    store: PropTypes.object,
  };
  static childContextTypes = {
    contentBucketBaseUrl: PropTypes.string,
    oldContentBucketBaseUrl: PropTypes.string,
    extraThumbnailPlaceholder: PropTypes.node,
    phonePrefixes: PropTypes.array,
  };

  getChildContext() {
    return {
      contentBucketBaseUrl: window.__additionalData.MEDIA_ROOT_URL_NG,
      oldContentBucketBaseUrl: window.__additionalData.MEDIA_ROOT_URL_NG_OLD,
      extraThumbnailPlaceholder: <img src={ExtrasPlaceholder} />,
      phonePrefixes: prefixes,
    };
  }

  isNotGiftCardSession() {
    return this.props.affiliate !== "giftcard";
  }

  isFromAbandonmentCart() {
    return Url.hasQueryParam("session");
  }

  isCheckoutLocation() {
    return window.location.href.indexOf("/checkout") > 0;
  }

  isAllowedRedirect() {
    return !(
      this.props.match.params.step !== "availability" ||
      !this.props.unavailableURL ||
      this.props.unavailableURL === "no_redirect" ||
      !window
    );
  }

  redirectToUnavailableURL() {
    const requestedParams = getFromLocalStorage(constants.LOCAL_STORAGE_KEYS.ARI_REQUEST_PARAMS);
    if (!this.state.cancelRedirect) {
      const timeout = this.props.hideUnavailableURLScreen ? 0 : 6000;
      setTimeout(() => {
        const url = copyURLParams(window.location.href, this.props.unavailableURL, {
          ...requestedParams.params,
          lang: this?.props?.locale || "es",
        });
        // This is a Sekuenz requirement for tracking
        if (url && !this.state.cancelRedirect) {
          redirectUrl(`${url}&redirect=${this.props.propertyTicker}`);
        }
      }, timeout);
    }
  }

  setCancelRedirect = () => {
    this.setState({
      cancelRedirect: true,
      redirectToUnavailableURL: false,
    });
  };

  handleResizeEvent() {
    if (window) {
      this.props.screenResize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
  }

  activateResizeListener() {
    this.handleResizeEvent();
    const component = this;
    window.addEventListener("resize", resizeThrottler, false);
    let resizeTimeout;
    function resizeThrottler() {
      // ignore resize events as long as an actualResizeHandler execution is in the queue
      // The actualResizeHandler will execute at a rate of 15fps
      if (!resizeTimeout) {
        resizeTimeout = setTimeout(function () {
          resizeTimeout = null;
          actualResizeHandler();
        }, 66);
      }
    }
    function actualResizeHandler() {
      component.handleResizeEvent();
    }
  }

  componentDidMount() {
    document.getElementsByTagName("html")[0].setAttribute("lang", this.props.locale);

    // Create IE + others compatible event handler
    const eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
    const eventer = window[eventMethod];
    const messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";
    // Listen to message from child window
    eventer(messageEvent, event => {
      if (event && event.data && event.data.gallery) {
        this.handleGalleryClose();
      }
    });
    this.props.getCountries(this.props.locale);
    /* When there's only one property, expand it */
    /*TODO: call validate and AddReservation action creator, with the reservations present on local storage*/
    require("iframe-resizer");
    if (
      this?.props?.session?.cartData?.length &&
      this.props.session.cartData[0]?.propertyTicker === this.props.propertyTicker
    ) {
      //Restore cart from session
      const reservations = this.props.session.cartData.map(reservation => ({
        endDate: new Date(reservation.end),
        startDate: new Date(reservation.start),
        numberOfUnits: reservation.numberOfUnits,
        propertyTicker: reservation.propertyTicker,
        inventory: reservation.inventory,
        promoCodes: this.props.session.promoCodes,
        id: reservation.id,
        guestAges: reservation.guestAges,
        guestAgesText: reservation.guestAgesText,
        paymentTypes: [],
        selectedServices: reservation.services ? reservation.services : {},
      }));
      this.props.validateReservations({
        reservations,
        locale: this.props.session.locale || this.props.locale,
        propertyTicker: this.props.propertyTicker,
        sessionId: this.props.session.id,
      });
    } else {
      const reservations = getFromSessionStorage(constants.LOCAL_STORAGE_KEYS.CART);
      if (reservations && reservations[this.props.propertyTicker]) {
        this.props.validateReservations({
          reservations: reservations[this.props.propertyTicker],
          locale: this.props.locale,
          propertyTicker: this.props.propertyTicker,
        });
      }
    }
    // we pass the referrer
    if (document.referrer && document.referrer.length > 0) {
      this.props.changeConfiguration({
        propertyTicker: this.props.propertyTicker,
        configuration: fromJS({ referrer: document.referrer }),
      });
    }
    const reservation = this.props.reservation;
    if (
      reservation &&
      getFromSessionStorage(constants.LOCAL_STORAGE_KEYS.RESERVATION_ID) === reservation.get("id")
    ) {
      this.props.createdReservation(reservation.get("id"));
    }
    window.wbkDataLayer = this.props.wbkDataLayer;
    executeEvent(constants.EVENTS.ENGINE_LOADED);
  }

  componentDidUpdate(prevProps) {
    if (this.state.redirectToUnavailableURL) {
      this.redirectToUnavailableURL();
    }
    if (
      !this.props.isPropertyChain &&
      !this.props.isPropertyAvailable &&
      this.props.isPropertyAvailable !== prevProps.isPropertyAvailable &&
      this.isAllowedRedirect()
    ) {
      this.setState({ redirectToUnavailableURL: true });
    }
    if (this.props.match.params.step !== prevProps.match.params.step) {
      if (window && window.parentIFrame) {
        window.parentIFrame.scrollTo(0, 0);
      }
    }
    /*TODO: HERE WE CAN CHECK IF THERE ARE ANY MESSAGES WHICH REQUIRE A MODAL  */
    if (
      this.props.invalidReservations &&
      this.props.invalidReservations !== prevProps.invalidReservations &&
      this.props.invalidReservations.size > 0
    ) {
      this.canOverWriteModal = false;
      this.setState({
        modal: {
          isOpen: true,
          children: (
            <div className={styles.invalidReservationModal}>
              <PopupLostReserved
                data={this.props.invalidReservations.toJS()}
                closeWindow={() => {
                  this.handleCloseModal();
                  if (this.isFromAbandonmentCart() && this.isCheckoutLocation()) {
                    this.props.history.push(constants.STEP_PATHS.STEP_1);
                  }
                }}
              />
            </div>
          ),
          options: { hideCloseButton: true },
        },
      });
    }
    if (this.props.invalidPayments && this.props.invalidPayments !== prevProps.invalidPayments) {
      this.setState({
        modal: {
          isOpen: true,
          children: (
            <div className={styles.invalidPaymentType}>
              <FormattedMessage {...appMsgs.invalidPayments} />
            </div>
          ),
          options: { hideCloseButton: false },
          closeButtonClass: "closeIcon",
          innerClass: "innerFlex",
          closeButtonContainerClass: "closeButtonContainer",
          showChildrenOverCloseButton: true,
        },
      });
    }
    if (this.props.locale !== null && this.props.locale != prevProps.locale) {
      /* TODO: get only when there's the countries field on the customer form */
      this.props.getCountries(this.props.locale);
    }
    window.wbkDataLayer = this.props.wbkDataLayer;

    if (this.props.affiliate && !this.state.firstLoadAffiliateDone) {
      const regexEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const isEmail = regexEmail.test(String(this.props.affiliate).toLowerCase());
      if (isEmail) {
        this.setState({ firstLoadAffiliateDone: true });
        this.addAlert(
          "info",
          `${this.props.intl.formatMessage(appMsgs.affiliateEmail)}: ${this.props.affiliate}`,
          null,
          {
            positionClass: "toast-top-center",
          }
        );
      }
    }
  }
  handleScroll(name, options = null) {
    const opt = options || {
      duration: 750,
      delay: 100,
      offset: -50,
      smooth: true,
      isDynamic: true,
    };
    setTimeout(() => scroller.scrollTo(name, opt), 0);
  }
  /*TODO: duplicate from checkout, centralize*/
  handleAddReservation() {
    this.props.history.push(`/${this.props.propertyTicker}`);
  }

  createCustomStyles(styles, fullWidth) {
    const sheet = document.createElement("style");
    let linkContainerBackgroundColor = styles.get("bookingFormBackgroundColor");
    let linkContainerOppositeColor = styles.get("bookingFormOppositeColor");
    if (fullWidth) {
      linkContainerBackgroundColor = styles.get("bookingFormButtonBackgroundColor");
      linkContainerOppositeColor = styles.get("bookingFormButtonOppositeColor");
      if (styles.get("headerLogoBackgroundColor")) {
        sheet.innerHTML +=
          "#wbkv9-App-BookingFormLogo { background-color: #" +
          styles.get("headerLogoBackgroundColor") +
          " }";
      }
    }
    if (styles.get("bodyBackgroundColor")) {
      sheet.innerHTML +=
        "body { background-color: #" +
        styles.get("bodyBackgroundColor") +
        " !important }" +
        ":root { background-color: #" +
        styles.get("bodyBackgroundColor") +
        " !important }" +
        "nav.navigation { background-color: #" +
        styles.get("bodyBackgroundColor") +
        " !important }" +
        ".wbkv9-FilterTab-element.active { border-bottom: 4px solid #" +
        styles.get("bodyBackgroundColor") +
        " !important }" +
        ".wbkv9-RoomSelection-Full-description .descriptionEllipsis { background-color: #" +
        styles.get("bodyBackgroundColor") +
        " !important }" +
        "@media only screen and (min-width: " +
        constants.DEVICE_SIZES.MIN_WIDTH_TABLET_HORIZONTAL +
        "px) {" +
        ".wbkv9-FilterTab-element.active { background-color: #" +
        styles.get("bodyBackgroundColor") +
        " }" +
        "}" +
        "@media only screen and (min-width: " +
        constants.DEVICE_SIZES.MIN_WIDTH_TABLET_HORIZONTAL +
        "px) {" +
        ".wbkv9-FilterTab-element:hover:not(.active) { background-color: #" +
        styles.get("bodyBackgroundColor") +
        " !important }" +
        "}";
    }
    if (styles.get("promotionsSeparatorColor")) {
      sheet.innerHTML +=
        ".promotionListContainer { border: 1px solid #" +
        styles.get("promotionsSeparatorColor") +
        " !important }" +
        ".promotionListContainer .promotionContainer { border-bottom: 1px solid #" +
        styles.get("promotionsSeparatorColor") +
        " !important }";
    }
    if (styles.get("bookingFormBackgroundColor")) {
      sheet.innerHTML +=
        ".bookingFormContainer, .wbkv9-ErrorScreen-header { background-color: #" +
        styles.get("bookingFormBackgroundColor") +
        " !important }" +
        "nav.navigation { border-bottom: 4px solid #" +
        linkContainerBackgroundColor +
        " !important }" +
        ".disabled .checkoutButton { background-color: #" +
        styles.get("bookingFormBackgroundColor") +
        " !important }" +
        ".checkoutEntityTitle { color: #" +
        styles.get("bookingFormBackgroundColor") +
        " !important }" +
        ".wbkv9-BookingForm-SearchButton { background-color: #" +
        linkContainerBackgroundColor +
        " !important }" +
        ".wbkv9-Menu-totalPromotions { background-color: #" +
        linkContainerBackgroundColor +
        " !important }" +
        "nav.navigation .linkContainer.active { background-color: #" +
        linkContainerBackgroundColor +
        " !important }" +
        "nav.navigation .linkContainer.active li { background-color: #" +
        linkContainerBackgroundColor +
        " !important";
      if (styles.get("bookingFormOppositeColor")) {
        sheet.innerHTML +=
          ";color: #" +
          linkContainerOppositeColor +
          " !important }" +
          ".fullWidthMode .dateRange .dateRangeIcon svg { fill: #" +
          styles.get("bookingFormOppositeColor") +
          " }" +
          ".fullWidthMode .bookingFormContainer .wbkv9-OccupantsWrapper-OccupantsSelector .wbkv9-OccupantsWrapper-OccupantsIcon svg { fill: #" +
          styles.get("bookingFormOppositeColor") +
          " }" +
          ".fullWidthMode .InputDate .InputDate-date { color: #" +
          styles.get("bookingFormOppositeColor") +
          " }" +
          ".wbkv9-OccupatnsWrapper-TotalOccupants { color: #" +
          styles.get("bookingFormOppositeColor") +
          " }" +
          ".wbkv9-Menu-totalPromotions { color: #" +
          styles.get("bookingFormOppositeColor") +
          " }" +
          ".guestAge { color: #" +
          styles.get("bookingFormOppositeColor") +
          " }" +
          ".wbkv9-FilterTab-element { color: #" +
          styles.get("bookingFormOppositeColor") +
          " !important }" +
          ".fullWidthMode .wbkv9-FilterTab-element { color: #404040 !important }" +
          ".wbkv9-App-BookingFormMenu svg { fill: #" +
          styles.get("bookingFormOppositeColor") +
          " !important }" +
          ".wbkv9-CalendarPicker-DateSeparator { color: #" +
          styles.get("bookingFormOppositeColor") +
          " !important }" +
          ".wbkv9-BookingFormSummary-Wrapper { color: #" +
          styles.get("bookingFormOppositeColor") +
          " !important }" +
          ".wbkv9-BookingFormSummary-EditText { color: " +
          hexToRGBAString("0x" + styles.get("bookingFormOppositeColor"), 0.5) +
          " !important }" +
          ".fullWidthMode .wbkv9-BookingForm-wrapper .wbkv9-OccupantsWrapper-OccupantsSelector .wbkv9-OccupantsWrapper-arrowDown svg { fill: " +
          hexToRGBAString("0x" + styles.get("bookingFormOppositeColor"), 0.5) +
          " !important }" +
          ".fullWidthMode .wbkv9-BookingForm-wrapper .wbkv9-OccupantsWrapper-OccupantsSelector .wbkv9-OccupantsWrapper-arrowDown path { fill: " +
          hexToRGBAString("0x" + styles.get("bookingFormOppositeColor"), 0.5) +
          " !important }" +
          ".fullWidthMode .wbkv9-BookingForm-wrapper .wbkv9-OccupantsWrapper-OccupantsSelector:hover .wbkv9-OccupantsWrapper-arrowDown svg { fill: " +
          hexToRGBAString("0x" + styles.get("bookingFormOppositeColor"), 1) +
          " !important }" +
          ".fullWidthMode .wbkv9-BookingForm-wrapper .wbkv9-OccupantsWrapper-OccupantsSelector:hover .wbkv9-OccupantsWrapper-arrowDown path { fill: " +
          hexToRGBAString("0x" + styles.get("bookingFormOppositeColor"), 1) +
          " !important }" +
          ".fullWidthMode .dateRange .dateRangeArrowDown svg { fill: " +
          hexToRGBAString("0x" + styles.get("bookingFormOppositeColor"), 0.5) +
          " !important }" +
          ".fullWidthMode .dateRange .dateRangeArrowDown svg path { fill: " +
          hexToRGBAString("0x" + styles.get("bookingFormOppositeColor"), 0.5) +
          " !important }" +
          ".fullWidthMode .dateRange:hover .dateRangeArrowDown svg { fill: " +
          hexToRGBAString("0x" + styles.get("bookingFormOppositeColor"), 1) +
          " !important }" +
          ".fullWidthMode .dateRange:hover .dateRangeArrowDown svg path { fill: " +
          hexToRGBAString("0x" + styles.get("bookingFormOppositeColor"), 1) +
          " !important }" +
          ".fullWidthMode .wbkv9-BookingForm-filters:hover .wbkv9-BookingForm-arrowDown svg { fill: " +
          hexToRGBAString("0x" + styles.get("bookingFormOppositeColor"), 1) +
          " !important }" +
          ".fullWidthMode .wbkv9-BookingForm-filters:hover .wbkv9-BookingForm-arrowDown svg path { fill: " +
          hexToRGBAString("0x" + styles.get("bookingFormOppositeColor"), 1) +
          " !important }" +
          ".fullWidthMode .wbkv9-BookingForm-filters .wbkv9-BookingForm-FilterIcon svg { fill: " +
          hexToRGBAString("0x" + styles.get("bookingFormOppositeColor"), 0.5) +
          " }" +
          ".fullWidthMode .wbkv9-BookingForm-filters:hover .wbkv9-BookingForm-FilterIcon svg { fill: " +
          hexToRGBAString("0x" + styles.get("bookingFormOppositeColor"), 1) +
          " }" +
          ".fullWidthMode .wbkv9-BookingForm-filters select { color: #" +
          styles.get("bookingFormOppositeColor") +
          "; border-bottom: 1px solid " +
          hexToRGBAString("0x" + styles.get("bookingFormOppositeColor"), 0.5) +
          " !important }" +
          ".fullWidthMode .wbkv9-BookingForm-filters:hover select { border-bottom: 1px solid " +
          hexToRGBAString("0x" + styles.get("bookingFormOppositeColor"), 1) +
          " !important }" +
          ".fullWidthMode .wbkv9-CalendarPicker-DateRange { border-bottom: 1px solid " +
          hexToRGBAString("0x" + styles.get("bookingFormOppositeColor"), 0.5) +
          " }" +
          ".fullWidthMode .wbkv9-CalendarPicker-DateRange:hover { border-bottom: 1px solid " +
          hexToRGBAString("0x" + styles.get("bookingFormOppositeColor"), 1) +
          " }" +
          ".wbkv9-OccupantsWrapper-OccupantsSelector { border-bottom: 1px solid " +
          hexToRGBAString("0x" + styles.get("bookingFormOppositeColor"), 0.5) +
          " }" +
          ".wbkv9-OccupantsWrapper-OccupantsSelector:hover { border-bottom: 1px solid " +
          hexToRGBAString("0x" + styles.get("bookingFormOppositeColor"), 1) +
          " }" +
          ".bookingFormContainer .promoCodesContainer { color: #" +
          styles.get("bookingFormOppositeColor") +
          " !important";
      }
      sheet.innerHTML +=
        " }" +
        "@media only screen and (min-width: " +
        constants.DEVICE_SIZES.MIN_WIDTH_TABLET_HORIZONTAL +
        "px) {" +
        ".wbkv9-FilterTab-element.active { color: #" +
        styles.get("bookingFormBackgroundColor") +
        " !important;" +
        "border-bottom: none !important }" +
        "}" +
        "@media only screen and (min-width: " +
        constants.DEVICE_SIZES.MIN_WIDTH_TABLET_HORIZONTAL +
        "px) {" +
        ".wbkv9-FilterTab-element:hover:not(.active) { color: #" +
        styles.get("bookingFormBackgroundColor") +
        " !important }" +
        ".fullWidthMode .wbkv9-FilterTab-element:hover:not(.active) { color: #000 !important }" +
        "}";
    }
    if (styles.get("bookingFormButtonBackgroundColor")) {
      if (fullWidth) {
        sheet.innerHTML +=
          ".wbkv9-CustomerForm-title { background-color: #" +
          styles.get("bookingFormButtonBackgroundColor") +
          " !important }" +
          ".wbkv9-PaymentForm-title { background-color: #" +
          styles.get("bookingFormButtonBackgroundColor") +
          " !important }" +
          ".wbkv9-Lib-ButtonPrice { background-color: #" +
          styles.get("bookingFormButtonBackgroundColor") +
          " !important }" +
          ".fullWidthMode .wbkv9-FilterTab-element.active { border: 1px solid #" +
          styles.get("bookingFormButtonBackgroundColor") +
          " !important;" +
          "background-color: #" +
          styles.get("bookingFormButtonBackgroundColor") +
          " !important; font-weight: 400 }" +
          ".wbkv9-FilterTab-selector { border: 1px solid #" +
          styles.get("bookingFormButtonBackgroundColor") +
          " !important;" +
          "background: #" +
          styles.get("bookingFormButtonBackgroundColor") +
          " !important }" +
          ".wbkv9-Checkout-totalTaxesContainer { background-color: #" +
          styles.get("bookingFormButtonBackgroundColor") +
          " !important }";
      }
      if (styles.get("bookingFormButtonOppositeColor")) {
        sheet.innerHTML +=
          ".wbkv9-BookingFormSummary-ExpandControl svg { fill: #" +
          styles.get("bookingFormButtonOppositeColor") +
          " !important }" +
          ".fullWidthMode .wbkv9-FilterTab-element.active { color: #" +
          styles.get("bookingFormButtonOppositeColor") +
          " !important }" +
          ".wbkv9-FilterTab-selector { color: #" +
          styles.get("bookingFormButtonOppositeColor") +
          " !important }" +
          ".wbkv9-Lib-ButtonPrice { color: #" +
          styles.get("bookingFormButtonOppositeColor") +
          " !important }" +
          ".wbkv9-PriceOption.wbkv9-PriceOption-selected { color: #" +
          styles.get("bookingFormButtonOppositeColor") +
          " !important }" +
          ".wbkv9-PriceOption-soldOut-selected { color: #" +
          styles.get("bookingFormButtonOppositeColor") +
          " !important }" +
          ".wbkv9-PriceOption-availabilityLink-selected { color: #" +
          styles.get("bookingFormButtonOppositeColor") +
          " !important }" +
          ".wbkv9-FilterTab-arrowDown svg { fill: #" +
          styles.get("bookingFormButtonOppositeColor") +
          " !important }" +
          ".wbkv9-FilterTab-arrowDown svg path { fill: #" +
          styles.get("bookingFormButtonOppositeColor") +
          " !important }" +
          ".wbkv9-Checkout-totalTaxesContainer { color: #" +
          styles.get("bookingFormButtonOppositeColor") +
          " !important }";
      }
      sheet.innerHTML +=
        ".buttonContainer button { background-color: #" +
        styles.get("bookingFormButtonBackgroundColor") +
        " !important";
      if (styles.get("bookingFormButtonOppositeColor")) {
        sheet.innerHTML +=
          ";color: #" + styles.get("bookingFormButtonOppositeColor") + " !important";
        if (fullWidth) {
          sheet.innerHTML +=
            "}.wbkv9-CustomerForm-title { color: #" +
            styles.get("bookingFormButtonOppositeColor") +
            " !important }" +
            ".wbkv9-PaymentForm-title { color: #" +
            styles.get("bookingFormButtonOppositeColor") +
            " !important }" +
            ".wbkv9-BookingForm-SearchButton svg { fill: #" +
            styles.get("bookingFormButtonOppositeColor") +
            " !important";
        }
      }
      sheet.innerHTML += " }";
      sheet.innerHTML +=
        ".wbkv9-BookingFormSummary-ExpandControl { background-color: #" +
        styles.get("bookingFormButtonBackgroundColor") +
        " !important }";
      const backgroundColor = hexToRGBAString(
        "0x" + styles.get("bookingFormButtonBackgroundColor"),
        0.2
      );
      sheet.innerHTML +=
        " .wbkv9-RoomSelection-promotionsCollapse { background-color: " +
        backgroundColor +
        " !important }";
      sheet.innerHTML +=
        " .wbkv9-RoomSelection-promotionsList-icon { background-color: #" +
        styles.get("bookingFormButtonBackgroundColor") +
        " !important }";
      sheet.innerHTML +=
        " .wbkv9-RoomSelection-promotionsCollapse { color: #" +
        styles.get("bookingFormButtonBackgroundColor") +
        " !important }";
      sheet.innerHTML +=
        " .wbkv9-PromotionTooltip-toolTipContent { background-color: #" +
        styles.get("bookingFormButtonBackgroundColor") +
        " !important }";
      sheet.innerHTML +=
        " .wbkv9-PriceOption.wbkv9-PriceOption-selected { background-color: #" +
        styles.get("bookingFormButtonBackgroundColor") +
        " !important }";
      sheet.innerHTML +=
        " .wbkv9-PromotionTooltip-toolTipArrow { border-left-color: #" +
        styles.get("bookingFormButtonBackgroundColor") +
        " !important }";
      const appliedFontColor = styles.get("bookingFormButtonOppositeColor")
        ? styles.get("bookingFormButtonOppositeColor")
        : styles.get("bookingFormButtonBackgroundColor");
      sheet.innerHTML +=
        " .wbkv9-PromotionTooltip-toolTipContent { color: #" + appliedFontColor + " !important }";
    }
    if (!fullWidth && styles.get("dropdownMenuColor")) {
      sheet.innerHTML +=
        "nav.navigation .DropdownMenu, nav.navigation .linkContainer li { color: #" +
        styles.get("dropdownMenuColor") +
        " !important }" +
        ".dropdown .icon svg { fill: #" +
        styles.get("dropdownMenuColor") +
        " !important }";
    }
    if (styles.get("logoBackgroundColor")) {
      sheet.innerHTML +=
        ".logoContainer, .mobileLogoContainer, .fullWidthlogoContainer { background-color: #" +
        styles.get("logoBackgroundColor") +
        " !important }";
    }
    if (styles.get("logoPadding")) {
      sheet.innerHTML += ".logoContainer { padding: 20px 0 !important }";
      // sheet.innerHTML += '.logoContainer { padding: ' + styles.get('logoPadding') + 'px 0 !important }';
    }
    if (styles.get("promotionsColor")) {
      sheet.innerHTML +=
        ".promotionListContainer .promotionContainer .title," +
        ".promotionListContainer .promotionContainer .reduction { color: #" +
        styles.get("promotionsColor") +
        " !important }";
      sheet.innerHTML +=
        ".promotionListContainer .promotionContainer .subtext { color: #" +
        styles.get("promotionsColor") +
        "; opacity: 0.4 !important }";
    }
    document.head.appendChild(sheet);
  }
  handleCloseModal(avoidCallback) {
    if (
      !avoidCallback &&
      this.state.modal &&
      this.state.modal.options &&
      typeof this.state.modal.options.handleClose === "function"
    ) {
      this.state.modal.options.handleClose();
    }
    this.setState({
      modal: {
        isOpen: false,
        children: (this.state.modal && this.state.modal.children) || null,
        options: (this.state.modal && this.state.modal.options) || {},
      },
    });
    if (this.state.modal && this.state.modal.options && this.state.modal.options.onClose) {
      this.state.modal.options.onClose();
    }
    this.props.notifyInvalidReservations({});
    this.props.notifyInvalidPayments({ value: false });
    this.canOverWriteModal = true;
  }

  setModalContentState = ({ content, options }) => {
    this.setState({
      modal: {
        isOpen: true,
        children: content,
        options: options,
      },
    });
  };

  handleModalContent(content, options, dontOverwrite) {
    if (dontOverwrite) {
      this.canOverWriteModal = false;
      this.setModalContentState({ content, options });
      return;
    }
    if (this.canOverWriteModal) {
      this.setModalContentState({ content, options });
    }
  }
  /*TODO: duplicate from checkout, centralize*/
  handleAddReservation() {
    this.props.history.push(`/${this.props.propertyTicker}`);
  }
  renderModalContent() {
    if (this.state.modal) {
      const content = this.state.modal.children;
      return (
        <div
          className={classnames(
            "appModal",
            this.state.modal.options && this.state.modal.options.className
          )}>
          {content}
        </div>
      );
    }
    return null;
  }
  handleMultiConditions = () => {
    if (this.props.cart && this.props.cart.filteredConditions) {
      const filteredConditions = this.props.cart.filteredConditions;
      const conditions = [];
      for (const key in filteredConditions) {
        if (filteredConditions.hasOwnProperty(key)) {
          conditions.push(
            <Conditions.PopupConditions
              data={filteredConditions[key].toJS()}
              closeWindow={this.handleCloseModal}
            />
          );
        }
      }
      this.handleModalContent(conditions, {
        hideCloseButton: true,
        modalWidth: "700px",
      });
    }
  };
  handleShareBookingCart() {
    let styles = {};
    if (!this.props.isWithotel && window.innerWidth >= 768) {
      styles = {
        content: {
          top: "300px",
        },
      };
    }
    this.handleModalContent(
      <Popup
        headerText={<FormattedMessage {...appMsgs.bookingShare} />}
        closeWindow={this.handleCloseModal}
        srcLogo={<ShoppingCartIcon />}>
        <ShareBooking
          propertyTicker={this.props.propertyTicker}
          locale={this.props.locale}
          affiliate={this.props.affiliate}
          origin={this.props.origin}
          mode={this.props.mode}
        />
      </Popup>,
      {
        styles,
        className: `wbkv9-Modal-ShareBooking ${styles.shareBookingModal}`,
        hideCloseButton: true,
      }
    );
  }
  addAlert(type, message, title, options = {}) {
    if (this.refs.toastcontainer) {
      const toastOptions = {
        closeButton: true,
        timeOut: 5000,
        positionClass: "toast-bottom-center",
        showAnimation: (this.props.iframeMode && "animated slideInDown") || "animated slideInUp",
        hideAnimation: "animated fadeOut",
        preventDuplicates: false,
        ...options,
      };
      this.refs.toastcontainer[type](message, title, toastOptions);
    }
  }
  handleGallery(images, title, description, options, inventory, extraAction, type, infoOnly) {
    try {
      if (window.self !== window.top && !this.props.isWithotel) {
        window.parent.postMessage(
          {
            eventType: "galleryOpened",
            images,
            options,
            title,
            description,
            inventory,
          },
          "*"
        );
      } else {
        const headerIframe = document.getElementById("wbkv9-HeaderIframe");
        const footerIframe = document.getElementById("wbkv9-FooterIframe");
        if (headerIframe) {
          headerIframe.style.display = "none";
        }
        if (footerIframe) {
          footerIframe.style.display = "none";
        }
        this.setState({
          gallery: {
            isOpen: true,
            images: images,
            title: title,
            description: description,
            inventory: inventory,
            options: options,
            extraAction,
            type,
            infoOnly,
          },
        });
      }
    } catch (exception) {
      console.log("Error opening gallery");
      console.log(exception);
    }
  }
  handleGalleryClose() {
    const headerIframe = document.getElementById("wbkv9-HeaderIframe");
    const footerIframe = document.getElementById("wbkv9-FooterIframe");
    if (headerIframe) {
      headerIframe.style.display = "block";
    }
    if (footerIframe) {
      footerIframe.style.display = "block";
    }
    this.setState({
      gallery: {
        isOpen: false,
        imagesList: [],
        description: null,
        options: {},
      },
    });
  }
  handleGalleryInventory(ticker, cb) {
    if (typeof this.state.gallery.extraAction === "function") {
      this.state.gallery.extraAction();
    }
    this.handleGalleryClose();
  }
  handleChangeConfiguration(newConfiguration) {
    this.props.changeConfiguration({
      propertyTicker: this.props.propertyTicker,
      configuration: newConfiguration,
    });
  }
  handleChangeLocale(newConfiguration) {
    this.props.changeConfiguration({
      propertyTicker: this.props.propertyTicker,
      configuration: newConfiguration,
    });
    this.props.changeLocale({
      propertyTicker: this.props.propertyTicker,
      locale: newConfiguration.locale,
    });
  }

  handleExpandPromotions(value = null) {
    if (value === null || (value !== null && this.props.expandedPromotions !== value)) {
      this.props.togglePromotions();

      if (!this.props.expandedPromotions) {
        if (window.innerWidth < 640) {
          window.scrollTo(0, 120);
        } else {
          window.scrollTo(0, 80);
        }
      }
    }
  }

  handleAnalyticsClientData({ gaClientId, gaReferrer }) {
    let host = constants.DEFAULT_HOST;
    if (window) {
      host = window.location.hostname;
    }
    // TODO: pass this info through each header
    this.props.setTrackingData({ gaClientId, gaReferrer, host });
  }
  pushState(event, path, killAction) {
    event && event.preventDefault();
    if (!killAction) {
      this.props.history.push(path);
    }
  }
  getFullWidthTypeClassName(fullWidthType) {
    if (!fullWidthType) {
      return null;
    }
    switch (fullWidthType) {
      case constants.FULL_WIDTH_TYPE.FIXED_HEADER_AND_MINIFORM:
        return "wbkv9-App--fixedHeaderAndMiniform";
      case constants.FULL_WIDTH_TYPE.FIXED_MINIFORM:
        return "wbkv9-App--fixedMiniform";
      case constants.FULL_WIDTH_TYPE.FLOATING_MAP:
        return "wbkv9-App--floatingMap";
      default:
        return null;
    }
  }
  getMapViewCenter() {
    if (this.props.propertyContact) {
      return {
        lat: this.props.propertyContact.get("latitude"),
        lng: this.props.propertyContact.get("longitude"),
      };
    }
    return {
      lat: -25.363882,
      lng: 131.044922,
    };
  }
  getMapMarker() {
    if (this.props.propertyContact) {
      return [
        {
          type: "marker",
          position: new google.maps.LatLng(
            this.props.propertyContact.get("latitude"),
            this.props.propertyContact.get("longitude")
          ), // eslint-disable-line
        },
      ];
    }
  }
  generateMapView() {
    return <MapView initialMarkers={this.getMapMarker()} initialCenter={this.getMapViewCenter()} />;
  }
  handleWithotelMenu(action) {
    if (this.props.isWithotel && window.self !== window.top) {
      window.parent.postMessage({ eventType: "handleMenu", action }, "*");
    }
  }
  render() {
    /*TODO: HACK TO RECOGNIZE CURRENT STATE AND COMPONENT TO HIDE PROMO LIST*/
    const showPromotionList = this.props.showPromotionList;
    const {
      match,
      propertyTicker,
      propertyType,
      reservations,
      messages,
      allPromotions,
      logos,
      availableCurrencies,
      currency,
      availableLocales,
      locale,
      globalLoadingActive,
      iframeMode,
      showPromos,
      isPropertyAvailable,
      fullWidth,
      isPropertyChain,
      customStyles,
      ariLoading,
      defaultCurrency,
      propertyContact,
      creditCardTypes,
      media,
      propertyName,
      showElementsConfig,
      cancelRelease,
      externalConfiguration,
      externalReservation,
      reservationCreated,
      startDate,
      endDate,
      propertyIsDemo,
      propertyTitle,
      analyticsLoaded,
      tripAdvisorLoaded,
      configuration,
      pendingAmountTextConfiguration,
      externalMarkupLoaded,
      isAnalyticsLoaded,
      gaData,
      isTripAdvisorLoaded,
      isExternalMarkupLoaded,
      fullWidthType,
      hotelSiteURL,
      menuMarkup,
      menuButtonMarkup,
      isWithotel,
      wbkDataLayer,
      bMindTracker,
      error,
      ARI,
      propertyData,
      expandedPromotions,
      isBookingFormSummaryOpened,
      toggleBookingFormSummary,
      origin,
      cart: {
        pendingTotal,
        bookingTotalRate,
        depositTotal,
        bookingOriginalRate,
        depositOriginalRate,
        pendingOriginal,
        startDateList,
      } = {},
      channel,
      cookieConsent,
      hideUnavailableURLScreen,
      deviceInfo,
      setStayQueueIndex,
      stayQueueIndex,
      showNewBookingForm,
      affiliate,
      loyaltyUser,
      showBackArrow,
      myAccountClicked,
      myReservationsClicked,
      encodedAffiliate,
    } = this.props;
    const {
      modal,
      gallery,
      isIframeRedirected,
      iframeRedirectError,
      redirectToUnavailableURL,
    } = this.state;

    if (isIframeRedirected) {
      return null;
    }
    if (this.props.status && this.props.status === 404) {
      return (
        <ErrorScreen
          type={constants.ERROR_SCREEN.NOT_FOUND}
          logos={logos}
          showDesktopLogo={showElementsConfig && showElementsConfig.showDesktopLogo}
          showMobileLogo={showElementsConfig && showElementsConfig.showMobileLogo}
          hotelSiteURL={hotelSiteURL}
        />
      );
    }
    if (!ARI || !propertyData || !configuration || error || iframeRedirectError) {
      return (
        <ErrorScreen
          type={constants.ERROR_SCREEN.SERVER}
          logos={logos}
          showDesktopLogo={showElementsConfig && showElementsConfig.showDesktopLogo}
          showMobileLogo={showElementsConfig && showElementsConfig.showMobileLogo}
          hotelSiteURL={hotelSiteURL}
        />
      );
    }
    const {
      handleCloseModal,
      renderModalContent,
      handleExpandPromotions,
      addAlert,
      handleGallery,
      handleGalleryClose,
      handleModalContent,
      handleMultiConditions,
      handleScroll,
      handleGalleryInventory,
      handleAnalyticsClientData,
      handleShareBookingCart,
      generateMapView,
      handleWithotelMenu,
    } = this;
    const promotions = getPromotions(propertyTicker, allPromotions);
    const ToastMessageFactory = React.createFactory(ToastMessageAnimated);
    const currentStep = match.params.step;
    let iframeModeClass = {};
    iframeModeClass[styles["is-iframe"]] = configuration && configuration.get("iframeMode");
    const mainContainer = classnames(
      "row",
      "center-xs",
      styles.mainContainer,
      fullWidth && "fullWidthMode"
    );
    const fullWidthClassName = classnames(
      styles.rootContainer,
      ariLoading && styles.loading,
      fullWidth && "fullWidthMode"
    );
    const fullWidthTypeClassName = fullWidthType && this.getFullWidthTypeClassName(fullWidthType);
    const centerContainer = classnames(
      "wbkv9-App-centerContainer",
      styles.centerContainer,
      "col-xs-12",
      "col-lg-10",
      iframeModeClass
    );
    const rightContainer = classnames(styles.rightContainer, "col-lg-2");
    // Get limit date to cancel for each reservation
    // TOOD: Do it on selector!!
    // TODO: DUPLICATED ON CHECKOUT.js
    const cancelableUntilList = [];
    if (startDateList) {
      for (let startDate in startDateList) {
        cancelableUntilList.push({ startDate, cancelRelease });
      }
    }
    const markupPhase = (() => {
      switch (currentStep) {
        case constants.STEP_PATHS.STEP_1:
          return constants.MARKUP_PHASE.STEP_1;
        case constants.STEP_PATHS.STEP_2:
          return constants.MARKUP_PHASE.STEP_2;
        case constants.STEP_PATHS.STEP_3:
          return constants.MARKUP_PHASE.STEP_3;
        default:
          return "";
      }
    })();
    let markups = null;
    if (this.props.markups) {
      const phaseMarkups = this.props.markups.get(markupPhase) || [];
      let anyPhaseMarkups = this.props.markups.get(constants.MARKUP_PHASE.ALL) || [];
      anyPhaseMarkups =
        anyPhaseMarkups &&
        anyPhaseMarkups.filter(
          markup =>
            markup.get("name") !== constants.MENU_MARKUP &&
            markup.get("name") !== constants.MENU_BUTTON_MARKUP
        );
      markups = [...phaseMarkups, ...anyPhaseMarkups];
    }
    const showPromosList =
      showPromos && showElementsConfig.showPromos && showPromotionList && promotions;

    const promotionList2 =
      allPromotions.get(propertyTicker) && getPromotions(propertyTicker, allPromotions);
    const promotionList = [...promotionList2];
    const availablePromos = showElementsConfig.showPromos && promotionList.length > 0;

    let expandedBookables = this.props.expandedBookables;
    expandedBookables = (expandedBookables && expandedBookables.split(",")) || [];
    expandedBookables = expandedBookables.length > 1;
    const isIE11 =
      deviceInfo &&
      deviceInfo.get("browserName") === "Internet Explorer" &&
      deviceInfo.get("browserVersion") === "11.0";

    const DivBookingForm = styled.div`
      position: sticky;
      top: -1px;
      z-index: 1000;
    `;

    return (
      <div
        id={currentStep}
        className={classnames("wbk-App", "wbkv9-App", fullWidthClassName, fullWidthTypeClassName)}>
        <Helmet
          title={(configuration && configuration.get("witbookerPageTitle")) || propertyName}
          link={[
            {
              rel: "shortcut icon",
              href: constants.FAVICON.replace("{{propertyTicker}}", propertyTicker).replace(
                "{{mediaRootUrl}}",
                window.__additionalData.MEDIA_ROOT_URL
              ),
            },
          ]}
        />

        {bMindTracker && (
          <BMindTracker
            wbkDataLayer={wbkDataLayer}
            currentStep={currentStep}
            propertyTicker={propertyTicker}
            expandedBookables={expandedBookables}
            origin={origin}
          />
        )}

        {!bMindTracker && (
          <DataLayerTracker wbkDataLayer={wbkDataLayer} currentStep={currentStep} />
        )}

        <GoogleAnalytics
          gaCodeNumber={gaData && gaData.gaCodeNumber}
          gaDomains={gaData && gaData.gaDomains}
          propertyTicker={propertyTicker}
          defaultCurrency={defaultCurrency}
          currentStep={currentStep}
          startDate={startDate}
          endDate={endDate}
          externalReservation={externalReservation}
          reservationCreated={reservationCreated}
          isPropertyAvailable={isPropertyAvailable}
          loaded={analyticsLoaded}
          isLoaded={isAnalyticsLoaded}
          sendClientData={handleAnalyticsClientData}
        />

        <ExternalMarkup
          markups={markups}
          currentStep={currentStep}
          reservationCreated={reservationCreated}
          externalConfiguration={externalConfiguration}
          externalReservation={externalReservation}
          loaded={externalMarkupLoaded}
          isLoaded={isExternalMarkupLoaded}
        />

        <TripAdvisorPixel
          currentStep={currentStep}
          reservationCreated={reservationCreated}
          externalConfiguration={externalConfiguration}
          externalReservation={externalReservation}
          loaded={tripAdvisorLoaded}
          isLoaded={isTripAdvisorLoaded}
        />

        {propertyIsDemo && <div className={styles.isDemo} />}
        {redirectToUnavailableURL && (
          <MessageOverlay visible={!hideUnavailableURLScreen}>
            <RedirectLoadingScreen onClickCancel={this.setCancelRedirect} />
          </MessageOverlay>
        )}

        {globalLoadingActive && (
          <div className={classnames("wbkv9-App-loadingOverlay", styles.loadingOverlay)}>
            <Loader />
          </div>
        )}
        <ToastContainer
          toastMessageFactory={ToastMessageFactory}
          ref="toastcontainer"
          className={(iframeMode && "toast-top-center") || "toast-bottom-center"}
        />

        {modal && (
          <Modal
            isOpen={modal.isOpen}
            options={modal.options}
            closeButtonClass={modal.closeButtonClass}
            closeButtonContainerClass={modal.closeButtonContainerClass}
            innerClass={modal.innerClass}
            showChildrenOverCloseButton={modal.showChildrenOverCloseButton}
            closeModal={event => handleCloseModal(event, false)}
            iframeMode={iframeMode}
            shouldCloseOnOverlayClick={modal.options && modal.options.shouldCloseOnOverlayClick}
            shouldCloseOnEsc={modal.options && modal.options.shouldCloseOnEsc}>
            {renderModalContent()}
          </Modal>
        )}
        {isIE11 && (
          <IEUpdateMessage>
            <div>
              <div>
                <FormattedMessage {...appMsgs.IEHeader} />
              </div>
              <div>
                <FormattedMessage {...appMsgs.IESubHeader} />
              </div>
            </div>
            <a href={`https://browser-update.org/${locale}/update.html`} target="_blank">
              <FormattedMessage {...appMsgs.IEUpdate} />
            </a>
          </IEUpdateMessage>
        )}
        {fullWidth && showNewBookingForm && showElementsConfig.showBookingForm && (
          <DivBookingForm id="booking-form">
            <ThemeProvider theme={theme}>
              <BookingFormWrapper
                addAlert={addAlert}
                ariLoading={ariLoading}
                currentStep={currentStep}
                handleConditions={handleMultiConditions}
                handleCloseModal={handleCloseModal}
                handleGallery={handleGallery}
                handleModalContent={handleModalContent}
                handleScroll={handleScroll}
                handleWithotelMenu={handleWithotelMenu}
                iframeMode={iframeMode}
                isBookingFormSummaryOpened={isBookingFormSummaryOpened}
                isWithotel={isWithotel}
                menuMarkup={menuMarkup}
                menuButtonMarkup={menuButtonMarkup}
                showBookingForm={showElementsConfig.showBookingForm}
                showMenu={showElementsConfig.showMenu}
                toggleBookingFormSummary={toggleBookingFormSummary}
                theme={theme}
                loyaltyUser={loyaltyUser}
                encodedAffiliate={encodedAffiliate}
                showBackArrow={showBackArrow}
                myAccountClicked={myAccountClicked}
                myReservationsClicked={myReservationsClicked}
              />
            </ThemeProvider>
          </DivBookingForm>
        )}
        {fullWidth && !showNewBookingForm && (
          <div className={classnames("wbkv9-App-HeaderContainer", styles.headerContainer)}>
            <BookingFormWrapperOld
              menuMarkup={menuMarkup}
              menuButtonMarkup={menuButtonMarkup}
              isWithotel={isWithotel}
              ariLoading={ariLoading}
              isBookingFormSummaryOpened={isBookingFormSummaryOpened}
              handleWithotelMenu={handleWithotelMenu}
              toggleBookingFormSummary={toggleBookingFormSummary}
              currentStep={currentStep}
              addAlert={addAlert}
              handleGallery={handleGallery}
              handleModalContent={handleModalContent}
              handleConditions={handleMultiConditions}
              handleCloseModal={handleCloseModal}
              handleScroll={handleScroll}
              iframeMode={iframeMode}
              showMenu={showElementsConfig.showMenu}
              showBookingForm={showElementsConfig.showBookingForm}
            />
          </div>
        )}

        <StickyContainer
          className={classnames(
            "wbkv9-StickyContainer",
            styles.stickyContainer,
            `${this.props.loyalty && styles.stickyLoyaltyContainer}`
          )}>
          {/*<div style={{'backgroundColor': 'red', 'height': '200px', 'width': '100%' }}></div>*/}

          <div className={mainContainer}>
            <div id="centerContainer" className={centerContainer}>
              {showElementsConfig.showMobileLogo && (
                <div className="mobileLogoContainer">
                  {logos && (
                    <a href={hotelSiteURL} target="_blank">
                      <img src={logos.get("logoMobile").get("url")} />
                    </a>
                  )}
                </div>
              )}
              <div
                className={classnames("wbkv9-App-fullWidthContainer", styles.fullWidthContainer)}>
                {this.props.children &&
                  this.props.children({
                    addAlert: addAlert,
                    handleGallery: handleGallery,
                    handleModalContent: handleModalContent,
                    handleConditions: handleMultiConditions,
                    handleCloseModal: handleCloseModal,
                    handleScroll: handleScroll,
                    handleShareBookingCart,
                    handleWithotelMenu,
                    handleExpandPromotions,
                    iframeMode: iframeMode,
                    generateMapView: generateMapView,
                    toggleBookingFormSummary: toggleBookingFormSummary,
                    setStayQueueIndex: setStayQueueIndex,
                    stayQueueIndex: stayQueueIndex,
                    loyaltyUser: loyaltyUser,
                  })}
              </div>
            </div>

            {!iframeMode &&
              (showElementsConfig.showDesktopLogo ||
                showPromosList ||
                currentStep === constants.STEP_PATHS.STEP_2) && (
                <div
                  className={classnames(
                    rightContainer,
                    currentStep === constants.STEP_PATHS.STEP_1 && styles.availability
                  )}>
                  {showElementsConfig.showDesktopLogo && (
                    <div className="logoContainer">
                      {logos && (
                        <a href={hotelSiteURL} target="_blank">
                          <img src={logos.get("logo").get("url")} />
                        </a>
                      )}
                    </div>
                  )}
                  {currentStep === constants.STEP_PATHS.STEP_2 && (
                    <CheckoutAdditionalInfo
                      className="desktop"
                      media={media}
                      pendingTotal={pendingTotal}
                      bookingTotalRate={bookingTotalRate}
                      depositTotal={depositTotal}
                      bookingOriginalRate={bookingOriginalRate}
                      depositOriginalRate={depositOriginalRate}
                      pendingOriginal={pendingOriginal}
                      currency={currency}
                      defaultCurrency={defaultCurrency}
                      propertyContact={propertyContact}
                      propertyName={propertyName}
                      creditCardTypes={creditCardTypes}
                      cancelableUntilList={cancelableUntilList}
                      handleModalContent={handleModalContent}
                      handleConditions={handleMultiConditions}
                      pendingAmountTextConfiguration={pendingAmountTextConfiguration}
                      handleAddReservation={this.handleAddReservation}
                      handleShareBookingCart={this.handleShareBookingCart}
                      handleGallery={handleGallery}
                    />
                  )}
                  {!fullWidth &&
                  currentStep === constants.STEP_PATHS.STEP_1 &&
                  messages &&
                  messages.get(constants.MESSAGE_POSITIONS.BELOW_LOGO_STEP_1)
                    ? messages
                        .get(constants.MESSAGE_POSITIONS.BELOW_LOGO_STEP_1)
                        .map((el, index) => (
                          <Notification
                            key={index}
                            id={el.get("id")}
                            position={el.get("position")}
                            text={<span dangerouslySetInnerHTML={renderHTML(el.get("content"))} />}
                            type={el.get("type").toLowerCase()}
                            propertyTicker={propertyTicker}
                            hideIcon={true}
                            closeIcon={true}
                          />
                        ))
                    : false}
                  {showPromosList && (
                    <PromotionList
                      promotions={promotions}
                      layout={PORTRAIT_LAYOUT}
                      currency={currency}
                    />
                  )}
                  {/* </div>
                    } */}
                  {/* </Sticky> */}
                </div>
              )}
          </div>

          <ImageGallery
            isOpen={gallery.isOpen}
            imagesList={gallery.images}
            title={gallery.title}
            description={gallery.description}
            inventory={gallery.inventory}
            options={gallery.options}
            type={gallery.type}
            infoOnly={gallery.infoOnly}
            handleInventory={handleGalleryInventory}
            handleGalleryClose={handleGalleryClose}
          />
          {/* {children} */}
        </StickyContainer>
      </div>
    );
  }
}
const ConnectedApp = connect(
  (state, ownProps) => {
    const path = ownProps.location.pathname;
    const showPromotionList =
      path.indexOf(constants.STEP_PATHS.STEP_2) === -1 &&
      path.indexOf(constants.STEP_PATHS.STEP_3) === -1;
    const propertyTicker = state.app.get("propertyTicker");
    const propertyType =
      state.app.get(constants.PROPERTY_ARI_KEY) &&
      state.app.get(constants.PROPERTY_ARI_KEY).get(propertyTicker) &&
      state.app.get(constants.PROPERTY_ARI_KEY).get(propertyTicker).get("type");
    // TODO: REFACTOR, USE ONLY SELECTORS
    const selectorData = createStructuredSelector({
      ARI: propertyARISelector,
      messages: messagesSelector,
      logos: logosSelector,
      promotions: promotionsSelector,
      customStyles: customStylesSelector,
      availableCurrencies: availableCurrenciesSelector,
      currency: currencySelector,
      locale: localeSelector,
      availableLocales: availableLocalesSelector,
      globalLoading: globalLoadingSelector,
      iframeMode: iframeModeSelector,
      showPromos: showPromosSelector,
      isPropertyAvailable: isPropertyAvailableSelector,
      fullWidth: fullWidthSelector,
      fullWidthType: fullWidthTypeSelector,
      isPropertyChain: isPropertyChainSelector,
      ariLoading: ariLoadingSelector,
      invalidReservations: reservationSelectors.denormalizedInvalidReservationsSelector,
      invalidPayments: reservationSelectors.invalidPaymentsSelector,
      reservations: reservationSelectors.reservationsSelector,
      cart: reservationSelectors.cartSelector,
      reservation: reservationSelector,
      defaultCurrency: defaultCurrencySelector,
      propertyContact: propertyContactSelector,
      propertyName: propertyNameSelector,
      creditCardTypes: creditCardTypesSelector,
      markups: markupsSelector,
      media: mediaSelector,
      showElementsConfig: showElementsConfigSelector,
      cancelRelease: cancelReleaseSelector,
      reservationCreated: reservationCreatedSelector,
      externalConfiguration: externalConfigurationSelector,
      configuration: configurationSelector,
      externalReservation: externalReservationSelector,
      gaData: gaDataSelector,
      startDate: startDateSelector,
      endDate: endDateSelector,
      propertyIsDemo: propertyIsDemoSelector,
      expandedBookables: expandedBookablesSelector,
      pendingAmountTextConfiguration: pendingAmountTextConfigurationSelector,
      isAnalyticsLoaded: analyticsLoadedSelector,
      isTripAdvisorLoaded: tripAdvisorLoadedSelector,
      isExternalMarkupLoaded: externalMarkupLoadedSelector,
      hotelSiteURL: hotelSiteURLSelector,
      menuMarkup: menuMarkupSelector,
      menuButtonMarkup: menuButtonMarkupSelector,
      isWithotel: isWithotelSelector,
      wbkDataLayer: wbkDataLayerSelector,
      bMindTracker: bMindTrackerSelector,
      propertyData: propertyDataSelector,
      expandedPromotions: expandedPromotionsSelector,
      isBookingFormSummaryOpened: isBookingFormSummaryOpenedSelector,
      unavailableURL: unavailableURLSelector,
      channel: channelSelector,
      cookieConsent: cookieConsentSelector,
      messageCode: messageCodeSelector,
      origin: originSelector,
      hideUnavailableURLScreen: hideUnavailableURLScreenSelector,
      deviceInfo: deviceInfoSelector,
      showNewBookingForm: showNewBookingFormSelector,
      affiliate: affiliateSelector,
      loyalty: loyaltySelector,
      encodedAffiliate: encodedAffiliateSelector,
      mode: modeSelector,
    })(state, ownProps);
    return {
      propertyTicker,
      propertyType,
      reservations: selectorData.reservations,
      pendingAmountTextConfiguration: selectorData.pendingAmountTextConfiguration,
      showPromotionList,
      invalidReservations: selectorData.invalidReservations,
      invalidPayments: selectorData.invalidPayments,
      ARI: selectorData.ARI,
      allPromotions: selectorData.promotions,
      messages: selectorData.messages,
      logos: selectorData.logos,
      availableCurrencies: selectorData.availableCurrencies,
      currency: selectorData.currency,
      availableLocales: selectorData.availableLocales,
      locale: selectorData.locale,
      customStyles: selectorData.customStyles,
      globalLoadingActive: selectorData.globalLoading,
      iframeMode: selectorData.iframeMode,
      showPromos: selectorData.showPromos,
      isPropertyAvailable: selectorData.isPropertyAvailable,
      fullWidth: selectorData.fullWidth,
      fullWidthType: selectorData.fullWidthType,
      isPropertyChain: selectorData.isPropertyChain,
      ariLoading: selectorData.ariLoading,
      cart: selectorData.cart,
      defaultCurrency: selectorData.defaultCurrency,
      propertyContact: selectorData.propertyContact,
      propertyTitle: selectorData.propertyTitle,
      propertyName: selectorData.propertyName,
      creditCardTypes: selectorData.creditCardTypes,
      markups: selectorData.markups,
      media: selectorData.media,
      showElementsConfig: selectorData.showElementsConfig,
      cancelRelease: selectorData.cancelRelease,
      reservationCreated: selectorData.reservationCreated,
      externalConfiguration: selectorData.externalConfiguration,
      configuration: selectorData.configuration,
      externalReservation: selectorData.externalReservation,
      gaData: selectorData.gaData,
      startDate: selectorData.startDate,
      endDate: selectorData.endDate,
      propertyIsDemo: selectorData.propertyIsDemo,
      reservation: selectorData.reservation,
      expandedBookables: selectorData.expandedBookables,
      isAnalyticsLoaded: selectorData.isAnalyticsLoaded,
      isTripAdvisorLoaded: selectorData.isTripAdvisorLoaded,
      isExternalMarkupLoaded: selectorData.isExternalMarkupLoaded,
      hotelSiteURL: selectorData.hotelSiteURL,
      menuMarkup: selectorData.menuMarkup,
      menuButtonMarkup: selectorData.menuButtonMarkup,
      isWithotel: selectorData.isWithotel,
      wbkDataLayer: selectorData.wbkDataLayer,
      bMindTracker: selectorData.bMindTracker,
      propertyData: selectorData.propertyData,
      expandedPromotions: selectorData.expandedPromotions,
      isBookingFormSummaryOpened: selectorData.isBookingFormSummaryOpened,
      unavailableURL: selectorData.unavailableURL,
      messageCode: selectorData.messageCode,
      channel: selectorData.channel,
      origin: selectorData.origin,
      hideUnavailableURLScreen: selectorData.hideUnavailableURLScreen,
      deviceInfo: selectorData.deviceInfo,
      showNewBookingForm: selectorData.showNewBookingForm,
      affiliate: selectorData.affiliate,
      loyalty: selectorData.loyalty,
      encodedAffiliate: selectorData.encodedAffiliate,
      mode: selectorData.mode,
    };
  },
  dispatch =>
    bindActionCreators(
      {
        ...actions,
        ...reservationActions,
        screenResize,
      },
      dispatch
    )
)(withSessionData(injectIntl(App)));
